import React from "react";

const Multiple_Variables = () => {
  return (
    <div>
      <h1>Multiple_Variables Component</h1>
      <p>Content for Multiple_Variables goes here...</p>
    </div>
  );
};

export default Multiple_Variables;
